var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.396 21.962"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.415 21.961v-10.02h3.34l.507-3.9H7.393V5.55c0-1.13.312-1.9 1.937-1.9h2.07V.16A26.821 26.821 0 008.388.004c-2.973 0-5.01 1.82-5.01 5.161v2.884H0v3.9h3.39V21.97z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMS4zOTYiIGhlaWdodD0iMjEuOTYyIiB2aWV3Qm94PSIwIDAgMTEuMzk2IDIxLjk2MiI+DQoJPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwKSI+DQoJCTxwYXRoIHN0eWxlPSJmaWxsOmN1cnJlbnRDb2xvcjsgc3Ryb2tlOiBub25lOyIgZD0iTTM2MC40MTUsMzYzLjI1MVYzNTMuMjMxaDMuMzRsLjUwNy0zLjloLTMuODY5VjM0Ni44NGMwLTEuMTMuMzEyLTEuOSwxLjkzNy0xLjlIMzY0LjR2LTMuNDlhMjYuODIxLDI2LjgyMSwwLDAsMC0zLjAxMi0uMTU2Yy0yLjk3MywwLTUuMDEsMS44Mi01LjAxLDUuMTYxdjIuODg0SDM1M3YzLjloMy4zOXYxMC4wMjFaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzUzIC0zNDEuMjkpIiAvPg0KCTwvZz4NCjwvc3ZnPg0K";
export { SvgFacebook as ReactComponent };